module.exports = __webpack_public_path__ + "static/media/flyer.7ae31ca7.png";